/**
 * Bereinigter Anzeigename eines externen Empfängers.
 *
 * Kundenfeedback 18.09.2026 (Fall Reichenbächer-Britta): Die Beteiligtenliste
 * der Akte liefert Namen als „Firma <adresse>“ (so werden sie in der
 * Beteiligten-Tabelle angezeigt). Wurde ein solcher Eintrag als Empfänger
 * übernommen, entstand beim Versand „Firma <adresse> <adresse>“ – eine
 * ungültige Adresse; Autohaus und Sachverständiger bekamen die Mail nicht.
 * Hier bleibt nur der Name übrig; ist keiner vorhanden, gibt es keinen
 * Anzeigenamen (die Mail geht dann an die nackte Adresse).
 */
export function cleanRecipientName (name: string | null | undefined, email?: string | null): string {
  let out = (name || '').replace(/<[^>]*>/g, ' ')
  const mail = (email || '').trim()
  if (mail) {
    out = out.split(mail).join(' ')
  }
  out = out.replace(/\s+/g, ' ').trim().replace(/^["']+|["']+$/g, '').trim()
  if (out.includes('@') && !out.includes(' ')) {
    return ''
  }
  return out
}
